import { ChangeDetectionStrategy, Component } from '@angular/core'
import * as EventTicketsActions from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.actions'
import { EventTicketsFacade } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.facade'
import { FormGroup } from '@angular/forms'
import { FormUtils } from 'libs/shared/utils/helpers/src/lib/form-utils'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'
import { GbEventTicketFormQuestionsService } from 'libs/shared/event-tickets/utils/src/lib/gb-event-ticket-form-questions.service'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src/lib/gb-front-dialog-service/gb-front-dialog.service'

@Component({
  selector: 'gb-event-ticket-questions-dialog',
  templateUrl: './gb-event-ticket-questions-dialog.component.html',
  styleUrls: ['./gb-event-ticket-questions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbEventTicketQuestionsDialogComponent {
  selectedEventTicket$ = this.eventTicketsFacade.selectedEventTicket$
  selectedEventTicketCustomFields$ = this.eventTicketsFacade.selectedEventTicketCustomFields$
  selectedEventTicketCustomValues$ = this.eventTicketsFacade.selectedEventTicketCustomValues$
  questionsForm = new FormGroup({})

  constructor(
    private eventTicketsFacade: EventTicketsFacade,
    private notificationService: GbNotificationService,
    private gbEventTicketFormQuestionsService: GbEventTicketFormQuestionsService,
    private gbFrontDialogService: GbFrontDialogService,
  ) {}

  onSubmit(): void {
    if (!this.questionsForm.valid) {
      FormUtils.markFieldsAsTouched(this.questionsForm)
      return this.notificationService.error('INVALID_FORM_ERROR_MESSAGE')
    }
    this.eventTicketsFacade.dispatch(
      EventTicketsActions.editEventTicket({
        payload: {
          custom_values: this.gbEventTicketFormQuestionsService.getFormattedCustomValues(this.questionsForm.value),
        },
        onSuccess: () => this.gbFrontDialogService.closeDialog(GbEventTicketQuestionsDialogComponent),
      }),
    )
  }
}
